import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AngularFireModule } from '@angular/fire';
import { environment } from '../environments/environment';
import { LandingPageComponent } from './components/landing-page/landing-page.component';
import { LoginComponent } from './components/login/login.component';
import { VideoStripComponent } from './components/video-strip/video-strip.component';
import { VideoGridComponent } from './components/video-grid/video-grid.component';
import { VideoItemComponent } from './components/video-item/video-item.component';
import { HeroVideoComponent } from './components/hero-video/hero-video.component';
import { HomeComponent } from './components/home/home.component';
import { SchoolsComponent } from './components/schools/schools.component';
import { RegisterComponent } from './components/register/register.component';
import { SportsComponent } from './components/sports/sports.component';
import {HttpClientModule} from '@angular/common/http';
import { SearchResultsComponent } from './components/search-results/search-results.component';
import { SearchOverlayComponent } from './components/search-overlay/search-overlay.component';
import {AngularFireAuthModule} from '@angular/fire/auth';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {AngularFireAuthGuard} from '@angular/fire/auth-guard';
import { AccountManagementComponent } from './components/account-management/account-management.component';
import { WatchComponent } from './components/watch/watch.component';
import { NoAccessModalComponent } from './components/no-access-modal/no-access-modal.component';
import {AngularFireFunctions, AngularFireFunctionsModule} from '@angular/fire/functions';
import {AngularFireDatabase, AngularFireDatabaseModule} from '@angular/fire/database';
import {DeactivateGuardService} from './guards/can-deactivate.guard';
import { SideNavComponent } from './components/side-nav/side-nav.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {PERFECT_SCROLLBAR_CONFIG, PerfectScrollbarModule} from 'ngx-perfect-scrollbar';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { FaqComponent } from './components/faq/faq.component';
import { AdminComponent } from './components/admin/admin.component';
import {NgSelectModule} from '@ng-select/ng-select';

/*Prime NG*/
import {InputSwitchModule} from 'primeng/inputswitch';
import {InputTextareaModule} from 'primeng/inputtextarea';
import {AngularFirestore} from '@angular/fire/firestore';
import { GiftPageComponent } from './components/gift-page/gift-page.component';
import { DeviceRegisterComponent } from './components/device-register/device-register.component';
import { VjsPlayerComponent } from './components/vjs-player/vjs-player.component';

@NgModule({
  declarations: [
    AppComponent,
    LandingPageComponent,
    LoginComponent,
    VideoStripComponent,
    VideoGridComponent,
    VideoItemComponent,
    HeroVideoComponent,
    HomeComponent,
    SchoolsComponent,
    RegisterComponent,
    SportsComponent,
    SearchResultsComponent,
    SearchOverlayComponent,
    AccountManagementComponent,
    WatchComponent,
    NoAccessModalComponent,
    SideNavComponent,
    ForgotPasswordComponent,
    FaqComponent,
    AdminComponent,
    DeviceRegisterComponent,
    GiftPageComponent,
    VjsPlayerComponent
  ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        AppRoutingModule,
        AngularFireModule.initializeApp(environment.firebase),
        AngularFireAuthModule,
        AngularFireDatabaseModule,
        AngularFireFunctionsModule,
        PerfectScrollbarModule,
        FormsModule,
        ReactiveFormsModule,
        NgSelectModule,
        InputTextareaModule,
        InputSwitchModule
    ],
  providers: [AngularFireAuthGuard, DeactivateGuardService, AngularFirestore],
  bootstrap: [AppComponent]
})
export class AppModule { }
